export default __webpack_public_path__ + "/images/google_logo.png";